import * as React from 'react';
import * as styles from './styles.css';

import { ArrowL16 } from '@cian/ui-kit/icons';
import { InlineText1 } from '@cian/ui-kit/typography';
import { IBackToPageProps } from './types';

export function BackToPageDesktop({ text, href, onClick }: IBackToPageProps) {
  return (
    <div className={styles['container']}>
      <a href={href} className={styles['link']} onClick={onClick}>
        <ArrowL16 color="current_color" />{' '}
        <span>
          <InlineText1 color="current_color">{text}</InlineText1>
        </span>
      </a>
    </div>
  );
}
